export default "__VITE_PUBLIC_ASSET__4e87fa19__"